import { Injectable, inject } from '@angular/core';

import { SportsCacheService } from '@frontend/sports/betting-offer/feature/sports-cache';
import { CountItem } from '@frontend/sports/common/core/data-access/sport-model';
import { Observable, map, startWith } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BaseNavigationItemsProvider {
    protected sportsCache = inject(SportsCacheService);

    readonly hasLiveItems$: Observable<boolean>;

    constructor() {
        this.hasLiveItems$ = this.sportsCache.getSportList().pipe(
            map((items: CountItem[]) => items.some((item) => item.counts.live)),
            startWith(false),
        );
    }
}
